(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionServiceList', PharmaReceptionServiceList);

	PharmaReceptionServiceList.$inject = [ '$resource' ];

	function PharmaReceptionServiceList($resource) {
		var resourceUrl = 'api/pharmaReceptionServiceList/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
